import { Locale } from '@ps-smart-cp/ppfw-client';

const leaseFeePaymentCycleNameConfig = {
  everyMonthly: new Map([
    [Locale.ja, '毎月'],
    [Locale.en, 'Every Monthly'],
  ]),
  everyTwoMonths: new Map([
    [Locale.ja, '2ヶ月毎'],
    [Locale.en, 'Every Two Months'],
  ]),
  everyThreeMonths: new Map([
    [Locale.ja, '3ヶ月毎'],
    [Locale.en, 'Every Three Months'],
  ]),
  everyFourMonths: new Map([
    [Locale.ja, '4ヶ月毎'],
    [Locale.en, 'Every Four Months'],
  ]),
  semiannually: new Map([
    [Locale.ja, '半年毎'],
    [Locale.en, 'Semiannually'],
  ]),
  annually: new Map([
    [Locale.ja, '1年毎'],
    [Locale.en, 'Annually'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { leaseFeePaymentCycleNameConfig };
